import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
import React from 'react';
import { compose } from 'recompose';
import SvgIcon from 'wfui-digital-core/es/SvgIcon';
import accessibleIcon from 'wfui-digital-core/es/accessibleIcon';

var BackIcon = function BackIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.000000, -24.000000)",
    fill: "#3B3331"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "\n                  M11.7095753,0.315719653 C12.1318154,0.735984308 12.0912494,1.30134033 11.6035199,1.79123217 C9.66939138,3.73380964\n                  7.69719969,5.70400868 5.78997604,7.60927099 C4.96478818,8.43364429 4.13960032,9.2580176 3.31482959,10.0828078\n                  C2.59194291,10.8054504 2.59256861,11.2017416 3.31743665,11.9261561 C4.83631207,13.4444039 6.3557089,14.9621305\n                  7.87510573,16.4799613 L11.2065162,19.8082031 L11.3076703,19.908683 C11.4435505,20.0433512 11.571818,20.1706188\n                  11.6871545,20.3018473 C12.097715,20.7685995 12.1027205,21.2887187 11.7008156,21.6931401 C11.501323,21.8938915\n                  11.2664787,22 11.0217276,22 C10.7806263,22 10.5421321,21.8955592 10.3317942,21.6979348 C9.69473204,21.0998498\n                  9.06444827,20.4647624 8.4551253,19.8506256 C8.23373344,19.6275685 8.01223729,19.4045114 7.79001117,19.1824966\n                  C6.97900573,18.3726115 6.16873028,17.5623096 5.35824626,16.7520077 C3.78775097,15.1814353 2.16365446,13.5576002\n                  0.562395821,11.963784 C0.254136587,11.6569241 0.0580853833,11.3754969 0,10.9019695 C0.0148081229,10.8710125 0.0296162457,10.8395344\n                  0.0446329337,10.8074308 C0.134733061,10.6151222 0.237034248,10.3971725 0.367387442,10.2656313 C3.33620751,7.26916098\n                  6.5762665,4.02670242 10.2727702,0.352826354 C10.5051118,0.12205603 10.7638368,0 11.0212061,0 C11.2639759,0\n                  11.5019487,0.109131224 11.7095753,0.315719653 Z\n                "
  })))))));
};

BackIcon.defaultProps = {
  width: '32px',
  height: '32px'
};
export default /*#__PURE__*/React.memo(compose(accessibleIcon)(BackIcon));